module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-700.a0f595e0.eot";